import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import Masonry from '@mui/lab/Masonry';

import workMoreList from '../db/work_more.json';

function WorkMore() {

    // const navigate = useNavigate();

    const gridWrap = {
        maxWidth:'calc(1756px + 60px)',
        width:'100%',
        margin:'0 auto 1rem',
        paddingLeft:"30px",
        boxSizing:"border-box",
        whiteSpace:"pre-line"
    }

    const itemHeight = {
        // maxHeight:"80vh",
        // height:"auto"
    }

    const smallTxt = {
        fontSize:"0.5rem"
    }

    return (
        <>
            <main className="py-16 bg-black/5">
                
                <h2 className="text-5xl pb-6 wrap">
                    WORKS
                </h2>
                <div style={gridWrap}>
                    <Masonry columns={{lg:5, md:3, sm:2}} spacing={4}>
                        {workMoreList.worklist.map(list=>(
                            <div className="relative overflow-hidden group duration-200 hover:drop-shadow-2xl max-h-72 h-auto" style={itemHeight} key={list.name}>
                                <img src={`${process.env.PUBLIC_URL}/images/portfolio/${list.img}`} alt="" className="w-full" />
                                <Link to={list.link} target="_blank" className="absolute inset-0 px-3 pt-3 bg-white/30 backdrop-blur-md opacity-0 duration-200 group-hover:opacity-100" style={smallTxt}>
                                    <span className="font-extralight border bg-neutral-700 text-white px-1 rounded-xl border-0">{list.cate}</span>
                                    <p className="text-sm">
                                        {list.name}<br />
                                    </p>
                                    <span className="inline-block w-full border-b-8 border-neutral-800 py-2 mb-4">
                                        {list.duration}
                                    </span>
                                    <button>
                                        <svg width="40" height="40" viewBox="0 0 95 94" xmlns="http://www.w3.org/2000/svg" className='fill-neutral-800'>
                                            <rect x="17" width="78" height="10"/>
                                            <rect x="85" width="10" height="78"/>
                                            <rect x="85.3555" y="2" width="10" height="120" transform="rotate(45 85.3555 2)" />
                                        </svg>
                                    </button>
                                </Link>
                            </div>
                        ))}
                    </Masonry>
                </div>
                <div className="wrap flex">
                    {/* <Link onClick={navigate(-1)} className="text-3xl ms-auto hover:text-cyan-200"> */}
                    <Link to="/" className="text-3xl ms-auto hover:text-cyan-200">
                        BACK
                    </Link>
                </div>

            </main>
        </>
    );
}

export default WorkMore;